import React, { useState } from "react";
import Header from "../layout/headerHome";
import ClinicLocator from "../element/component/ClinicLocator/ClinicLocator";
import { clinics } from "../../data/clinicData";
import Counter from "../element/component/Counter";
import FilterableClinics from "../element/component/FilterableClinics"
import TestimonialSlider from "../element/component/testimonial-slider";


const services = [
  {
    image: "/images/new-website/physiotherapy/physiotherapist.webp",
    color: "#f0f8e8",
    name: "Doctor Consultations",
    bgImage: "/images/new-website/clinics/stetoscope.webp",
  },
  {
    image: "/images/sugar-blood-test.webp",
    color: "#f0f8e8",
    name: "Diagnostics & Lab",
    bgImage: "/images/new-website/clinics/microscope.webp",
  },
  {
    image: "/images/new-website/clinics/pharmacy.webp",
    color: "#f0f8e8",
    name: "Pharmacy",
    bgImage: "/images/new-website/clinics/clean-tooth.webp",
  },
  {
    image: "/images/new-website/physiotherapy/back-neuro.webp",
    color: "#f0f8e8",
    name: "Physiotherapy",
    bgImage: "/images/new-website/clinics/physiotherapy-clinics.webp",
  },
  {
    image: "/images/new-website/dental/dental-implants.webp",
    color: "#f0f8e8",
    name: "Dental care",
    bgImage: "/images/new-website/clinics/clean-tooth.webp",
  },
  {
    image: "/images/heart-checkup.webp",
    color: "#f0f8e8",
    name: "L1 Emergency Services",
  },
  {
    image: "/images/new-website/diet-nutrition/nutrition.webp",
    color: "#f0f8e8",
    name: "Diet & Nutrition",
    bgImage: "/images/new-website/clinics/eye-checkup.webp",
  },
  {
    image: "/images/new-website/yoga/yogapage-expert.webp",
    color: "#f0f8e8",
    name: "Yoga & Fitness",
    bgImage: "/images/new-website/yoga/yogapage-expert.webp",
  },
  {
    image: "/images/new-website/clinics/syringe.webp",
    color: "#f0f8e8",
    name: "Vaccinations",
    bgImage: "/images/new-website/clinics/vaccination.webp",
  },
    {
    image: "/images/new-website/radiology/radiologist.webp",
    color: "#f0f8e8",
    name: "Nursing Care",
    bgImage: "/images/new-website/radiology/radiologist.webp",
  },
    {
    image: "/images/women-care-1.webp",
    color: "#f0f8e8",
    name: "Women's Health",
    bgImage: "/images/women-care-1.webp",
  },
  {
    image: "/images/new-website/home-new/healthcare-home.webp",
    color: "#f0f8e8",
    name: "Preventive Health",
  },
  {
    image: "/images/new-website/elder-care/diet.webp",
    color: "#f0f8e8",
    name: "Diabetes & Metabolic Care",
    bgImage: "/images/new-website/elder-care/diet.webp",
  },
  {
    image: "/images/new-website/clinics/eye-exam.webp",
    color: "#f0f8e8",
    name: "Eye & Hearing Care",
    bgImage: "/images/new-website/clinics/eye-checkup.webp",
  },
];

const cards = [
  {
    title: "High-Street Clinics",
    description:
      "Walk-in care for individuals and families in your neighbourhood.",
    link: "Explore Clinics",
    image: "/images/new-website/clinics/bh-clinic-street.webp",
    color: "blue",
  },
  {
    title: "Residential Community Clinics",
    description:
      "On-site primary, preventive, L1 emergency care for apartment communities & gated societies.",
    link: "Explore More",
    image: "/images/new-website/clinics/BH-clinic-society.webp",
    color: "green",
  },
  {
    title: "Corporate / OHC Clinics",
    description:
      "Holistic healthcare solutions for workplaces and organisations.",
    link: "Learn More",
    image: "/images/new-website/clinics/bh-corporate.webp",
    color: "purple",
  },
  {
    title: "Senior Living Community Clinics ",
    description:
      "Dedicated elder healthcare services, with round-the-clock support and emergency readiness. ",
    link: "Explore Clinics",
    image: "/images/new-website/clinics/bh-clinic-street.webp",
    color: "blue",
  },
];


const testimonials = [
    {
      content:
        "Bridge health offers services at affordable cost. Akshata at the front desk is very cooperative and good at coordinating and follow-ups. The staff are well spoken and carried out all tests with patience.",
      name: "Akshata J Lokhande",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "I am Prof Sundararaj living at PRIMUS REFLECTION. The staff are very courteous with a smile on their faces, including all the doctors. Special thanks to Ms. Akshita!",
      name: "Sundar Raj",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Good , clean hygiene place ... Feels like your are at home with the services that provide... I have enrolled for gym here.. And the trainers are thorough professionals.. And the staff I have interacted with them during the seminars or presentations they are knowledgeable",
      name: "Shiva Kumar S",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "From sattva apartment Bridge healthy is useful for our patients.Mahendra the nursing staff is good and courteous.",
      name: "Susheela Sharan",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Laxman is an excellent nurse looking after the retired community. Gentle in taking blood. Very polite and efficient.",
      name: "Dipak Rao",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
  ];


export default function BridgeHealth() {
  const [activeClinic, setActiveClinic] = useState(0);
  const [searchVal, setSearchVal]       = useState("");

const filteredClinics = clinics.filter((clinic) => {
  const keyword = searchVal.toLowerCase();

  return (
    clinic?.name?.toLowerCase()?.includes(keyword) ||
    clinic?.area?.toLowerCase()?.includes(keyword) ||
    clinic?.address?.toLowerCase()?.includes(keyword) ||
    clinic?.pincode?.includes(keyword) ||
    clinic?.services?.some(
      (service) =>
        service &&
        service.toLowerCase().includes(keyword)
    )
  );
});

  return (
    
    <div className="bh-root">
      <Header />
      {/* ── NAV ── */}
      {/* <nav className="bh-nav">
        <img src="/images/new-website/bhlogo.webp"></img>
        <ul className="bh-nav-links">
          {["Clinics", "Services", "Health Plans", "For Organizations", "About"].map((l) => (
            <li key={l}><a href="#">{l}</a></li>
          ))}
        </ul>
        <div className="bh-nav-actions">
          <button className="bh-nav-btn-signin">Sign in</button>
          <button className="bh-nav-btn-book">Book now</button>
        </div>
      </nav> */}

      {/* ── HERO ── */}
     <section className="clinic-hero">
      <div className="clinic-hero__content">
        <h1 className="clinic-hero-title">
          Multispecialty Clinics, Closer To You 
        </h1>

        <p className="clinic-hero-description">
          Bridge Health Primary & Preventive Care Clinics bring trusted healthcare closer to where you live and work. 
        </p>

        <div className="clinic-hero__features">
          <div className="clinic-hero__feature">
            <div className="clinic-hero-icon-bg">
              <img src="/images/new-website/physiotherapy/physiotherapist.webp"></img>
            </div>
            <span>Experienced Doctors</span>
          </div>

          <div className="clinic-hero__feature">
            <div className="clinic-hero-icon-bg">
              <img src="/images/heart-checkup.webp"></img>
            </div>
            <span>Modern Clinics</span>
          </div>

          <div className="clinic-hero__feature">
            <div className="clinic-hero-icon-bg">
              <img src="images/new-website/home-new/healthcare-home.webp"></img>
            </div>
            <span>Comprehensive Care</span>
          </div>
        </div>

        <div className="clinic-hero__buttons">
          <a href="#clinic-list">
          <button className="clinic-hero-btn clinic-hero-btn-primary">
            Find a Clinic Near You
          </button>
          </a>
          <a href="#organization">
          <button className="clinic-hero-btn clinic-hero-btn-secondary">
            Build a Clinic With Us
          </button>
          </a>
        </div>
      </div>

      <div className="clinic-hero__image-wrapper">
        <img
          src="/images/new-website/clinics/bridge-health-clinic-banner.webp"
          alt="Bridge Health"
          className="clinic-hero__image"
        />
      </div>
    </section>

    {/* 2nd Fold */}

     <section className="care-section">
      <div className="care-header">
        <div className="services-badge">
              <span className="services-badge-icon">❤</span>
              <span>CLINICS TYPES</span>
        </div>
        <h2>Care That Fits Every Need</h2>
        <p>
          Clinics for gated societies, workplaces, high street locations, and senior living communities 
        </p>
      </div>

      <div className="care-grid">
        {cards.map((card, index) => (
          <div className={`care-card ${card.color}`} key={index}>
            <div className="care-image">
              <img src={card.image} alt={card.title} />
            </div>

            <div className="care-content">
              <h3>{card.title}</h3>
              <p>{card.description}</p>

            </div>
          </div>
        ))}
      </div>
    </section>
    
    {/* — CLINICS — */}

      <section className="clinic-locator-section" id="clinic-list">

        <div className="clinic-locator-header">
          <div className="services-badge">
              <span className="services-badge-icon">❤</span>
              <span>CLINICS NEAR YOU</span>
            </div>
          <h2>Find a Bridge Health Clinic Near You</h2>
          <p>
            Explore our clinics across Bengaluru.
            Search by area, pincode or services.
          </p>
        </div>
        <FilterableClinics />
      </section>

      {/* ── SERVICES ── */}
      <section className="bh-services">
        <div className="bh-services-inner">
            <section className="services-heading">
              <div className="services-badge">
                <span className="services-badge-icon">❤</span>
                <span>OUR SERVICES</span>
              </div>

              <h2 className="services-title">
                Comprehensive Care For Every Need 
              </h2>

              <p className="services-subtitle">
                Expert care across a wide range of medical services for you and your family.
              </p>
            </section>
          <div className="bh-services-grid">
            {
            services.map((service, index) => (
              <div key={index} className="bh-service-card">
                <div
                  className="clinic-hero-icon"

                >
                  <img src={service.image} alt={service.name} />
                </div>

                <h3>{service.name}</h3>

              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <div className="bh-stats">
        {[
          {
            end: 55,
            suffix: "+",
            label: "Clinics Across India",
          },
          {
            end: 200000,
            suffix: "+",
            label: "Patients served",
          },
          {
            end: 100,
            suffix: "+",
            label: "Doctors & Specialists",
          },
          {
            end: 35,
            suffix: "+",
            label: "Corporates",
          },

        ].map((s) => (
          <div className="bh-stats-item" key={s.label}>
            <div className="bh-stats-number">
              <Counter
                end={s.end}
                suffix={s.suffix}
                decimals={s.decimals || 0}
                duration={2000}
              />
            </div>

            <div className="bh-stats-label">
              {s.label}
            </div>
          </div>
        ))}
      </div>


      {/* ── ORGS ── */}
      <section className="bh-orgs" id="organization">
        <div className="bh-orgs-inner">
          <div className="bh-orgs-left">
            <div className="services-badge">
              <span className="services-badge-icon">❤</span>
              <span>FOR ORGANIZATIONS</span>
            </div>
            <h2 className="bh-orgs-title">Bring a Bridge Health Clinic to Your Campus or Community </h2>
            <p className="clinic-hero-description">
              We partner with corporates, tech parks, factories, residential communities, SEZs, senior living facilities, and institutions to set up fully managed on-site healthcare clinics. From primary care, preventive health, NABL-accredited diagnostics, pharmacy services, wellness programs, and emergency support to real-time health analytics, we deliver end-to-end healthcare through our people, technology, and operations model.
            </p>
            <div className="benefit-lists">
            <ul className="bh-orgs-features">
              {[
                <>
                  <strong>High Client Retention</strong> – 95%+ renewal rate, with many centres operating for years.
                </>,
                <>
                  <strong>Large-Scale Impact</strong> – Serving over 3 lakh individuals through primary healthcare services.
                </>,
                <>
                  <strong>Family Doctor Model</strong> – Trusted first point of care for primary and preventive health needs.
                </>,
                <>
                  <strong>Flexible Operations</strong> – Clinics can operate up to 7 days a week or 24×7 based on requirements.
                </>,
                <>
                  <strong>Medicine Access</strong> – Well-stocked pharmacies with commonly prescribed medicines readily available.
                </>,
              ].map((f) => (
                <li key={f}>
                  <img
                    src="/images/new-website/clinics/check-mark.webp"
                    alt=""
                    className="bh-orgs-feature-icon"
                  />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
            <ul className="bh-orgs-features">
              {[
               <>
                  <strong>Hospital-Agnostic Care</strong> – Referrals made only when medically necessary, with complete patient choice.
                </>,
                <>
                  <strong>Continuity of Care</strong> – Family doctors support referrals and follow-up care for better outcomes.
                </>,
                <>
                  <strong>Strong Clinical Team</strong> – 150+ family physicians, nurses, physiotherapists, and 50+ visiting specialists.
                </>,
                <>
                  <strong>Quality & Safety</strong> – Services governed by robust clinical protocols and SOPs.
                </>,
                <>
                  <strong>Affordable Care Model</strong> – Competitive pricing, subscriptions, health camps, and wellness programs.
                </>
              ].map((f) => (
                <li key={f}>
                  <img
                    src="/images/new-website/clinics/check-mark.webp"
                    alt=""
                    className="bh-orgs-feature-icon"
                  />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
            </div>

          </div>
          <div className="bh-orgs-enquiry-card">
            <div className="bh-orgs-enquiry-title">Enquire about opening a clinic</div>
            <div className="bh-orgs-form-row">
              <div className="bh-orgs-form-group bh-input-icon">
                <img
                  src="/images/new-website/clinics/user-clinic.webp"
                  alt="User"
                  className="bh-input-icon-img"
                />
                <input placeholder="Your name" />
              </div>

              <div className="bh-orgs-form-group bh-input-icon">
                <img
                  src="/images/new-website/clinics/office-clinic.webp"
                  alt="Company"
                  className="bh-input-icon-img"
                />
                <input placeholder="Company / Society" />
              </div>
            </div>
            <div>
              <div className="bh-orgs-form-group bh-input-icon">
                <img
                  src="/images/new-website/clinics/phone-call-clinic.webp"
                  alt="Phone"
                  className="bh-input-icon-img"
                />
                <input placeholder="Phone Number" />
              </div>
            </div>
            <div className="bh-orgs-form-group">
                <label>Organisation type</label>
                <select>
                  <option>Select type</option>
                  <option>Corporate</option>
                  <option>Residential</option>
                  <option>Educational</option>
                  <option>Healthcare</option>
                </select>
            </div>
            <div className="bh-orgs-form-group">
              <label>Approximate employee / resident count</label>
              <select>
                <option>Select range</option>
                <option>Under 100</option>
                <option>100 – 500</option>
                <option>500 – 1,000</option>
                <option>1,000 – 5,000</option>
                <option>5,000+</option>
              </select>
            </div>
            <div className="bh-orgs-form-group">
            <label>Tell us more (optional)</label>
            <div className="bh-orgs-form-group">
              <textarea placeholder="Location, specific services needed, timeline…" />
            </div>
            </div>
            <button className="bh-orgs-form-submit">Request a Callback</button>
          </div>
        </div>
      </section>

      <section>
        <div className="clinic-corporate-slider">
                    <div class="slider">
                        <div class="slider-content">
                            <img src="/images/new-website/clinics/samhita-academy.webp" alt="samhita" />
                            <img src="/images/new-website/clinics/prestige-group.webp" alt="prestige" />
                            <img src="/images/new-website/clinics/brigade-logo.webp" alt="brigade" />
                            <img src="/images/new-website/clinics/sobha-logo.webp" alt="sobha" width="80%"/>
                            <img src="/images/new-website/home-scroll/mantri.webp" alt="mantri" width="70%" />
                            <img src="/images/new-website/clinics/primus-logo.webp" alt="primus" />
                            <img src="/images/new-website/clinics/l&t.webp" alt="l&t" />
                            <img src="/images/new-website/home-scroll/digit.webp" alt="digit" />
                            <img src="/images/new-website/home-scroll/bechem.webp" alt="bechem" width="80%" />
                            <img src="/images/new-website/home-scroll/acciona.webp" alt="acciona" />
                            <img src="/images/new-website/home-scroll/indiqube.webp" alt="indiqube" />
                            <img src="/images/new-website/clinics/Murr-elektronik.webp" alt="murrelektronik" />
                            <img src="/images/new-website/clinics/innovation-investment.webp" alt="innovation" />
                            <img src="/images/new-website/clinics/brookfield-properties.webp" alt="brookfield-properties" />
                            <img src="/images/new-website/clinics/gsp-logo.webp" alt="gsp-logo" />
                            <img src="/images/new-website/clinics/the-den.webp" alt="theden" />
                            <img src="/images/new-website/clinics/lemon-tree.webp" alt="lemon-tree" />
                            <img src="/images/new-website/clinics/digit.webp" alt="digit" />
                            <img src="/images/new-website/clinics/prestige-group.webp" alt="prestige" />
                            <img src="/images/new-website/clinics/brigade-logo.webp" alt="brigade" />
                            <img src="/images/new-website/clinics/sobha-logo.webp" alt="sobha" width="80%"/>
                            <img src="/images/new-website/home-scroll/mantri.webp" alt="mantri" width="70%" />
                            <img src="/images/new-website/clinics/primus-logo.webp" alt="primus" />
                            <img src="/images/new-website/clinics/l&t.webp" alt="l&t" />
                            <img src="/images/new-website/home-scroll/digit.webp" alt="digit" />
                            <img src="/images/new-website/home-scroll/bechem.webp" alt="bechem" width="80%" />
                        </div>
                    </div>
                    <div class="slider slider-row-reverse">
                        <div class="slider-content">
                            <img src="/images/new-website/home-scroll/simpl.webp" alt="Logo 1" />
                            <img src="/images/new-website/home-scroll/iitpl.webp" alt="Logo 2" />
                            <img src="/images/new-website/home-scroll/vertex.webp" alt="Logo 3" />
                            <img src="/images/new-website/home-scroll/nivetti.webp" alt="Logo 4" />
                            <img src="/images/new-website/home-scroll/prakat (1).webp" alt="Logo 5" />
                            <img src="/images/new-website/home-scroll/consark.webp" alt="Logo 1" />
                            <img src="/images/new-website/home-scroll/bhoruka.webp" alt="Logo 2" />
                            <img src="/images/new-website/home-scroll/synthesis.webp" alt="Logo 3" />
                            <img src="/images/new-website/home-scroll/genei.webp" alt="Logo 4" />
                            <img src="/images/new-website/home-scroll/eagle-detective-agency.webp" alt="Logo 5" />
                            <img src="/images/new-website/clinics/atto.webp" alt="atto" />
                            <img src="/images/new-website/clinics/att.webp" alt="att" />
                            <img src="/images/new-website/clinics/adroit.webp" alt="adroit" />
                            <img src="/images/new-website/clinics/imanage.webp" alt="imanage" />
                            <img src="/images/new-website/clinics/acctpro.webp" alt="acctpro" />
                            <img src="/images/new-website/clinics/infosys.webp" alt="infosys" />
                            <img src="/images/new-website/clinics/mfine.webp" alt="mfine" />
                            <img src="/images/new-website/clinics/verizon.webp" alt="verizon" />
                            <img src="/images/new-website/clinics/country-road.webp" alt="countryroad" />
                            <img src="/images/new-website/clinics/lilly.webp" alt="lilly" />
                            <img src="/images/new-website/clinics/mj.webp" alt="mj" />
                             <img src="/images/new-website/home-scroll/simpl.webp" alt="Logo 1" />
                            <img src="/images/new-website/home-scroll/iitpl.webp" alt="Logo 2" />
                            <img src="/images/new-website/home-scroll/vertex.webp" alt="Logo 3" />
                            <img src="/images/new-website/home-scroll/nivetti.webp" alt="Logo 4" />
                            <img src="/images/new-website/home-scroll/prakat (1).webp" alt="Logo 5" />
                            <img src="/images/new-website/home-scroll/consark.webp" alt="Logo 1" />
                        </div>
                    </div>
        </div>
      </section>

 
      {/* ── TESTIMONIALS ── */}
      <section className="bh-testimonials">
            <div className="services-badge">
              <span className="services-badge-icon">❤</span>
              <span>WHAT PEOPLE SAY</span>
            </div>
                <h2 className="services-title">
              Trusted by Communities Across India
            </h2>
            
      </section>

      <section>
        <div className="testimonials-container">
      {/* Left Side */}
      <div className="left-section-testimonial">
        
        <div className="ratings">
          <img
            src="/images/new-website/women-care/google-logo-1.webp"
            alt="Google Logo"
          />
          <div>
            <p>
              4.9{" "}
              <span className="stars">
                ⭐⭐⭐⭐⭐
              </span>
            </p>
            <p>Customer Reviews</p>
          </div>
        </div>
        <h3 className="google-rating">Google Rating</h3>
        <a href="https://g.page/r/CagLkxSu4CfZEBM/review" target="_blank" rel="noopener noreferrer">
        <button className="clinic-hero-btn-primary">Write a Review</button>
        </a>
      </div>

      {/* Right Side */}
      <div className="right-section-testimonial">
        <div className="testimonial-page">
      <TestimonialSlider testimonials={testimonials} />
    </div>
      </div>
    </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="bh-footer">
        <div className="bh-footer-inner">
          <div className="bh-footer-grid">
            <div>
              <img src="/images/bh-logo-light.webp" width="50%"></img>
              <p className="bh-footer-tagline">
                Primary care &amp; diagnostics across Bengaluru.<br />
                Accessible, affordable, accountable.
              </p>
            </div>
            <div>
              <div className="bh-footer-col-title">Clinics</div>
              <ul className="bh-footer-links">
                {["Indiranagar", "Koramangala", "Whitefield", "HSR Layout", "+ 4 more"].map((l) => (
                  <li key={l}><a href="#">{l}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <div className="bh-footer-col-title">Services</div>
              <ul className="bh-footer-links">
                {["General physician", "Diagnostics", "Dental", "Mental wellness"].map((l) => (
                  <li key={l}><a href="#">{l}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <div className="bh-footer-col-title">Organizations</div>
              <ul className="bh-footer-links">
                {["Open a clinic", "Corporate health", "Residential", "Contact us"].map((l) => (
                  <li key={l}><a href="#">{l}</a></li>
                ))}
              </ul>
            </div>
          </div>
          <div className="bh-footer-bottom">
            <div className="bh-footer-bottom-copy">©2025 Bridge Health. All rights reserved.</div>
            <div className="bh-footer-bottom-links">
              <a href="#">Privacy policy</a>
              <a href="#">Terms of use</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}